
export default {
  name: 'VsSkeleton',
  inheritAttrs: false,
  provide() {
    return {
      skeleton: this
    }
  },
  inject: {
    skeleton: {
      default: null
    }
  },
  props: {
    rows: {
      type: Number,
      default: 1
    },
    gap: {
      type: [String, Object],
      default: 'sm'
    },
    animated: {
      type: Boolean,
      default: true
    },
    borderRadius: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isAnimated() {
      return this.skeleton ? this.skeleton.animated : this.animated
    },
    radius() {
      return this.skeleton ? this.skeleton.borderRadius : this.borderRadius
    }
  }
}
